/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Too_ManyInputs */

const en_issue_too_many = /** @type {(inputs: Issue_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a product holds at most this many images`)
};

/**
* | output |
* | --- |
* | "a product holds at most this many images" |
*
* @param {Issue_Too_ManyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_too_many = /** @type {((inputs?: Issue_Too_ManyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Too_ManyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_too_many(inputs)
});